<template>
    <div class="LifeExpress">
        <slider-question v-bind="{
            title: 'What is your outstanding debt?',
            description: 'What is the total amount of your outstanding debt? <br>(e.g. mortgages, personal loans, etc.)',
            min: 0,
            type: 'money',
            format: 'thousands',
            max: 200000,
            tick: 50000,
            step: 10000,
            value: this.$store.state.debts,
            customVal: this.$store.state.customDebts,
            name: 'debts',
            customName: 'customDebts',
            next: 'results'
        }">
        </slider-question>

        <slot />
    </div>
</template>

<script>
    import SliderQuestion from '../components/questions/SliderQuestion.vue';
    export default {
        name: 'ExpressLife',
        components: {
            SliderQuestion
        },
        created: function() {
            this.$store.commit('update', { name: 'calculator', value: 'express' });
            this.$store.commit('update', { name: 'product', value: 'life' });
        }
    }
</script>

<style lang="scss" scoped>
    .LifeExpress {
        text-align: center;
    }
</style>
